var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingPulseBarFast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "84px",
    height: "84px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 44,
    width: 18,
    height: 12,
    fill: "#85a2b6"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    repeatCount: "indefinite",
    dur: "0.641025641025641s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "39.8;44;44",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-0.12820512820512822s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    repeatCount: "indefinite",
    dur: "0.641025641025641s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "20.400000000000002;12;12",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-0.12820512820512822s"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 44,
    width: 18,
    height: 12,
    fill: "#bbcedd"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    repeatCount: "indefinite",
    dur: "0.641025641025641s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "40.85;44;44",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-0.06410256410256411s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    repeatCount: "indefinite",
    dur: "0.641025641025641s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "18.3;12;12",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    begin: "-0.06410256410256411s"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 44,
    width: 18,
    height: 12,
    fill: "#dce4eb"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    repeatCount: "indefinite",
    dur: "0.641025641025641s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "40.85;44;44",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    repeatCount: "indefinite",
    dur: "0.641025641025641s",
    calcMode: "spline",
    keyTimes: "0;0.5;1",
    values: "18.3;12;12",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingPulseBarFast);
export default __webpack_public_path__ + "static/media/loadingPulseBarFast.96eddbdc3ec503db7a7fe10424da72ff.svg";
export { ForwardRef as ReactComponent };